import { GetServerSideProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Fragment } from 'react';

import { EventListContent } from '@/components/ui/features/ hubs-conferences/EventList/EventListContent';
import { EventsSearchInput } from '@/components/ui/features/ hubs-conferences/EventsSearchInput/EventsSearchInput';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { EventListStatus } from '@/enums/EventListStatus';
import { EventSort } from '@/enums/EventSort';
import { getHubBySlug, getHubsSubtree } from '@/queries/hubs';
import { queryThinEventsList } from '@/queries/thin-events';
import { generateStore } from '@/utils/generateStore';
import { Hydrate, IHydrateProps } from '@/utils/swr/Hydrate';
import { StringParam, urlQueryStringValidate } from '@/utils/url-query-string';

const Publishers: NextPage<IHydrateProps> = ({ fallback }) => {
  return (
    <Fragment>
      <NextSeo title="Hub Conferences" />
      <Hydrate fallback={fallback}>
        <Layout accessFrom={AccessFrom.Hubs}>
          <EventsSearchInput />
          <EventListContent />
        </Layout>
      </Hydrate>
    </Fragment>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });
  const { slug, query, sort, subject_subtree_of_id, conference_id, year_starts_at } = urlQueryStringValidate<{
    slug: string;
    query: string;
    sort: EventSort;
    subject_subtree_of_id: string;
    conference_id: string;
    year_starts_at: string;
  }>(context.query, {
    slug: StringParam,
    query: StringParam,
    sort: StringParam,
    subject_subtree_of_id: StringParam,
    conference_id: StringParam,
    year_starts_at: StringParam,
  });

  // since useLibraryFilters does not work here
  const filters = {
    subject_subtree_of_id,
    conference_id,
    year_starts_at,
  };

  const { data } = await store.fetchResource(getHubBySlug(slug));
  const { data: subtreeIds } = await store.fetchResourceRelationship(getHubsSubtree(data.id));

  const baseFilters = {
    subject_id: subtreeIds,
    query,
    scope: EventListStatus.past,
    library: 'true',
  };

  await store.fetchResourcesInfinite(queryThinEventsList({ ...baseFilters, ...filters }, sort));

  return {
    props: {
      fallback: store.fallback,
    },
  };
};

export default Publishers;
